import { Typography, Box } from "@mui/material";
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import styles from "@/components/todos/todoNote.module.css";
import { useTranslation } from "react-i18next";

interface TodoNoteProps {
  note: {
    payload: string;
  };
}

export default function TodoNote({ note }: TodoNoteProps) {
  const { t } = useTranslation();

  if (!note || !note.payload) {
    return null;
  }

  const formattedNote = note.payload.replace(/\\n/g, '\n');

  return (
    <Box className={styles.todoNoteContainer}>
      <Box className={styles.headerWrapper}>
        <StickyNote2Icon className={styles.todoNoteIcon} />
        <Typography
          variant="body2"
          className={styles.todoNoteTitle}
        >
          {t("note_attached_to_todo") + ":"}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        className={styles.todoNoteText}
        style={{ whiteSpace: "pre-line" }}
      >
        {formattedNote}
      </Typography>
    </Box>
  );
}
